export default "__VITE_ASSET__S0URuAcf__"